function TableGdd({
  tableAnalysis,
  totalGrowingDegreeDays,
  plantingDate,
  harvestDate,
}) {
  return (
    <>
      <div className="flex flex-col justify-center items-center mt-5">
        <div className="flex flex-row justify-center items-center h-full w-full">
          <div
            className="w-[230px] text-center text-president font-bold text-[16px] !font-[B-Nazanin] rounded-[5px]"
            style={{
              borderTop: "1.5px solid black",
              borderRight: "1.5px solid black",
              borderBottom: "0.75px solid black",
              borderLeft: "0.75px solid black",
              backgroundColor: "rgba(70, 15, 129, 0.20)",
            }}
          >
            ارقام پیشنهادی
          </div>
          <div
            className="w-[220px] text-center text-president text-[16px] rounded-tl-[5px] font-bold !font-[B-Nazanin]"
            style={{
              borderTop: "1.5px solid black",
              borderRight: "0.75px solid black",
              borderBottom: "0.75px solid black",
              borderLeft: "0.75px solid black",
              backgroundColor: "rgba(70, 15, 129, 0.20)",
            }}
          >
            وضعیت
          </div>
        </div>

        {tableAnalysis.map((cultivar, index) => (
          <div
            key={index}
            className="flex flex-row justify-center items-center w-full"
          >
            <div
              className={`w-[230px] text-center text-[#333] ${
                tableAnalysis?.length - 1 === index && "rounded-br-[5px]"
              } text-[16px] font-bold !font-[B-Nazanin]`}
              style={{
                borderTop: "0.75px solid black",
                borderRight: "1.5px solid black",
                borderBottom: "0.75px solid black",
                borderLeft: "0.75px solid black",
              }}
            >
              {cultivar?.name}
            </div>
            <div
              dir="ltr"
              className={`flex flex-row items-center justify-around w-[220px] px-2 text-center text-[#333] text-[16px] font-bold ${
                tableAnalysis?.length - 1 === index && "rounded-bl-[5px]"
              } !font-[B-Nazanin]`}
              style={{
                borderTop: "0.75px solid black",
                borderRight: "0.75px solid black",
                borderBottom: "0.75px solid black",
                borderLeft: "0.75px solid black",
              }}
            >
              <div
                className={`Ellipse41 w-3 h-3 ${
                  totalGrowingDegreeDays > cultivar.growingDegreeDays
                    ? "bg-[#008F47]"
                    : "bg-[#EC1818]"
                } rounded-full shadow`}
              />
              {totalGrowingDegreeDays > cultivar.growingDegreeDays
                ? "متناسب با بازه فصل رشد"
                : "نامتناسب با بازه فصل رشد"}
            </div>
          </div>
        ))}
      </div>
      {!(totalGrowingDegreeDays > tableAnalysis[0]?.growingDegreeDays) &&
      tableAnalysis.length === 1 ? (
        <p className="!font-[B-Nazanin] text-xs font-bold text-center  mt-2 flex flex-row gap-1 w-[400px] justify-center items-baseline">
          {" "}
          <div className=" w-3 h-2 bg-[#EC1818] rounded-full shadow" /> هیچ رقمی
          متناسب با بازه فصل رشد انتخابی شما یافت نشد. رقمی که پیشنهاد شده است
          در صورت کاشت در تاریخ {plantingDate} دیرتر از تاریخ {harvestDate}{" "}
          برداشت خواهد شد.
        </p>
      ) : null}
    </>
  );
}

export default TableGdd;
